import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { SessionModel } from './../../../session/entities/sessionModel';
import { IAppState } from './../../../appState/app.state';
import { Store } from '@ngrx/store';
import { environment } from './../../../../environments/environment';


import { IChangePasswordService } from './changePassword.service.Interface';
import { ChangePasswordModel } from './../entities/changePasswordModel';
import { PASSWORT_GEAENDERT, PasswortGeaendertAction } from '../../../appState/app.actions';
import { AppState } from '../../../appState/appStateStore.module';
import { PasswordChangedModel } from '../entities/passwordChangedModel';

@Injectable()
export class ChangePasswordService implements IChangePasswordService {

  constructor(private http: HttpClient, private store: Store<AppState>) { }

  change(changePassword: ChangePasswordModel): Promise<PasswordChangedModel> {

    const url = environment.apiBaseUrl + `logon/changePw`;
    let session: SessionModel = null;

    this.store.take(1).subscribe(s => session = s.app.session);

    if (!session.user || !session.token) {
      return Promise.reject('Keine gültige Anmeldung!');
    }

    changePassword.Username = session.user;
    const headers = new HttpHeaders()
        .set('authorization', 'Bearer ' + session.token)
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json');

    const promise = new Promise<PasswordChangedModel>((resolve, reject) => {
      this.http.put<PasswordChangedModel>(url, changePassword, { headers: headers })
        .subscribe((pwChanged: PasswordChangedModel) => {
          this.store.dispatch(new PasswortGeaendertAction(pwChanged));
          resolve(pwChanged);
        },
        (err) => {
          const msg = err.error;
          if (msg.Message.indexOf('Trivialpasswort') >= 0) {
            reject('Sie haben ein Trivialpasswort verwendet. Bitte verwenden Sie ein anderes Passwort.');
          }
          if (msg.Message.indexOf('Passwort wurde schon einmal verwendet') >= 0) {
            reject(msg.Message);
          }
          reject('Ihre Änderung ist fehlgeschlagen.');
        });
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/account/changepassword/services/changePassword.service.ts